import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow } from 'ui-components/components/flex';

import { cleanLocationString } from '../helpers';

export const Name = ({ name }) => {
  const cleanName = cleanLocationString(name);
  if (!cleanName) {
    return null;
  }
  return <FlexRow>{cleanName}</FlexRow>;
};

Name.propTypes = {
  name: PropTypes.string,
};
